import { Injector } from "@angular/core";
import { LookupGetService } from "../service/lookup-service/lookup-get.service";

export class DrugIngredientUtil {

 static getSubstance(value: string): string {
    let outputValue: string = '[Substance]';

    outputValue = value?value:outputValue;

    return outputValue;

  }

  static getStrength(concentrationtypeCode: number):string {
    let value: string = '';

    switch (concentrationtypeCode) {
      case 5:
        value = 'At Approximately';
        break;
      case 6:
        value = 'At an Average of';
        break;
      case 1:
        value = 'At';
        break;
      case 4:
        value = 'At Not less than';
        break;
      case 2:
        value = 'In a Range of';
        break;
      case 3:
        value = 'At Up to';
        break;
    }

    return value;
  }

  static getRole(lookUpService: LookupGetService, searchedValue: any):string{
    let value: string = '[role]';

    const valueFromSelect = this.getSelectedValueFromCache(lookUpService,searchedValue,'roleofingredient');
    return  valueFromSelect?valueFromSelect:value;

  }

  static getLowNumerator(value: any): string {
    let outputValue = '[value]';

    outputValue = value?value:outputValue;

    return outputValue;
  } 

  static getLowNumeratorPrefix(lookUpService: LookupGetService, searchedValue: any):string {
    let value = '[prefix]'; 
    let valueFromSelect = this.getSelectedValueFromCache(lookUpService,searchedValue,'amountprefix');

    return valueFromSelect? valueFromSelect: value;
  } 

  static getLowNumeratorUnit(lookUpService: LookupGetService, searchedValue: any):string {
    let value = '[unit]';
    let valueFromSelect = this.getSelectedValueFromCache(lookUpService,searchedValue,'amountnumerunit');

    return valueFromSelect? valueFromSelect: value;
  } 

  static getLowDenominator(value: any): string {
    let OutputValue = '[value]';

    OutputValue = value?value:OutputValue;

    return OutputValue;
  } 

  static getLowDenominatorPrefix(lookUpService: LookupGetService, searchedValue: any):string {
    let value = '[prefix]';
    let valueFromSelect = this.getSelectedValueFromCache(lookUpService,searchedValue,'amountprefix');

    return valueFromSelect? valueFromSelect: value;
  } 

  static getLowDenominatorUnit(lookUpService: LookupGetService, model: any):string {
    let value = '[unit]';
    let searchedValue = model.lowAmountConditionalGroup?.lowamountdenomunit?.value;
    let lookUpWithValues = '';
    switch (model.expressedAs) {
      case 1:
        lookUpWithValues = 'unitofmeasurement';
        break;
      case 2:
        lookUpWithValues = 'unitofpresentation';
        break;
    }

    let valueFromSelect = lookUpWithValues != ''?this.getSelectedValueFromCache(lookUpService,searchedValue,lookUpWithValues):'';

    return valueFromSelect? valueFromSelect: value;
  } 

  static getHighNumerator(value: any):string {
    let outputValue = '[value]';

    outputValue = value?value:outputValue;

    return outputValue;
  } 

  static getHighNumeratorPrefix(lookUpService: LookupGetService, searchedValue: any):string {
    let value = '[prefix]';
    let valueFromSelect = this.getSelectedValueFromCache(lookUpService,searchedValue,'amountprefix');

    return valueFromSelect? valueFromSelect: value;
  } 

  static getSelectedValueFromCache(lookUpService: LookupGetService, valueFromModel: any, lookUpName: string): string {
    return valueFromModel ? lookUpService.retrieveValueFromCache(lookUpName,valueFromModel): '';
  }

  static getFullDescription(lookUpService: LookupGetService, model: any) {
    let fullDescription = '';
    fullDescription = fullDescription + this.getSubstance(model.substancecode.name);
    fullDescription = fullDescription + ' as ';
    fullDescription = fullDescription + this.getRole(lookUpService,model.roleofingredient);
    let strength = this.getStrength(model.concentrationtypecode?.value);

    if (strength != '') {
      fullDescription = fullDescription + ' ';
      fullDescription = fullDescription + strength;
      fullDescription = fullDescription + ' ';
      fullDescription = fullDescription + this.getLowNumerator(model.lowamountnumervalue);
      fullDescription = fullDescription + ' ';
      fullDescription = fullDescription + this.getLowNumeratorPrefix(lookUpService, model.lowAmountConditionalGroup?.lowamountnumerprefix?.value);

      if (model.concentrationtypecode?.value == 2) {
        fullDescription = fullDescription + ' to ';
        fullDescription = fullDescription + this.getHighNumerator(model.highAmountConditionalGroup?.highamountnumervalue);
        fullDescription = fullDescription + ' ';
        fullDescription = fullDescription + this.getHighNumeratorPrefix(lookUpService, model.highAmountConditionalGroup?.highamountnumerprefix?.value);
      }

      fullDescription = fullDescription + ' ';
      fullDescription = fullDescription + this.getLowNumeratorUnit(lookUpService, model.lowAmountConditionalGroup?.lowamountnumerunit?.value);
      fullDescription = fullDescription + ' per ';
      fullDescription = fullDescription + this.getLowDenominator(model.lowamountdenomvalue);
      fullDescription = fullDescription + ' ';
      fullDescription = fullDescription + this.getLowDenominatorPrefix(lookUpService, model.lowAmountConditionalGroup?.lowamountdenomprefix?.value);
      fullDescription = fullDescription + ' ';
      fullDescription = fullDescription + this.getLowDenominatorUnit(lookUpService, model);
    } 

    return fullDescription;
  }

  static setStrength(injector: Injector, model: any) {
    const lowAmountDenomunitValue =
      model.lowAmountConditionalGroup?.lowamountdenomunit?.value;
    let result = model.strength ? model.strength : null;
    if (lowAmountDenomunitValue && result == null) {
      // try to load from unitofmeasurement
      let lookupNameToCheck = 'unitofmeasurement';
      if (
        injector.get(LookupGetService).retrieveValueFromCache(
          lookupNameToCheck,
          lowAmountDenomunitValue
        ) != ''
      ) {
        result = 1;
      } else {
        lookupNameToCheck = 'unitofpresentation';
        if (
          injector.get(LookupGetService).retrieveValueFromCache(
            lookupNameToCheck,
            lowAmountDenomunitValue
          ) != ''
        ) {
          result = 2;
        }
      }
      model.strength = result;
    }
  }

}
